"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const r = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.256 21.869a.875.875 0 0 1 0-1.238L16.888 12 8.256 3.369A.875.875 0 1 1 9.494 2.13l9.243 9.243a.885.885 0 0 1 0 1.252l-9.243 9.243a.875.875 0 0 1-1.238 0Z",
        clipRule: "evenodd"
      }
    )
  }
), m = l(r);
export {
  m as ChevronRight,
  m as default
};
